require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./blog-the-role-of-project-management-on-software-development.json") })
        }
      }, "path---blog-the-role-of-project-management-on-software-development");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---blog-the-role-of-project-management-on-software-development!./.cache/json/blog-the-role-of-project-management-on-software-development.json
// module id = 842
// module chunks = 231608221292675